import { Injectable } from '@angular/core';
import { CierreAdministrativoRequest, CierreAdministrativoResponse, ExpedienteCierreAdministrativoResponse } from '../models/cierre-administrativo.interface';
import { HttpClient } from '@angular/common/http';
import { environment } from '@env/environment';
import { BackendAuthService } from './backend-auth.service';
import { SessionService } from './session.service';
import { firstValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CierreAdministrativoService {

  constructor(private http: HttpClient, private authService: BackendAuthService, private sessionService: SessionService) { }

  async obtenerExpediente(expId: number): Promise<{ success: string, data: ExpedienteCierreAdministrativoResponse }> {
     const tokenRes = await this.authService.obtenerToken();
     const token = tokenRes.access_token;
     const http = this.http.get<{ success: string, data: ExpedienteCierreAdministrativoResponse }>(
      `${environment.backendUrl}/esi-expediente-cierre-administrativo?exp_id=${expId}`,
      {
        headers: {
          'Authorization': 'Bearer ' + token,
          'session_id': this.sessionService.getToken() || ''
        }
      }
    );
    return firstValueFrom(http);
  }

  async realizarCierre(data: CierreAdministrativoRequest): Promise<{ success: string, data: CierreAdministrativoResponse }> {
    const tokenRes = await this.authService.obtenerToken();
    const token = tokenRes.access_token;
    const http = this.http.post<{ success: string, data: CierreAdministrativoResponse }>(
      `${environment.backendUrl}/esi-cierre-administrativo`,
      data,
      {
        headers: {
          'Authorization': 'Bearer ' + token,
          'session_id': this.sessionService.getToken() || ''
        }
      }
    );
    return firstValueFrom(http);
  }
}
